import NumberFormat from "react-number-format";
import { Link } from "react-router-dom";

const ContentCard = ({ item }) => {
  const priceAfterDiscount =
    item.originalPrice - (item.originalPrice * item.discountPercent) / 100;
  return (
    <div className="overflow-hidden pt-1.5 rounded-lg h-72 sm:h-[340px] shadow-lg hover:shadow-2xl hover:scale-105">
      <div>
        {item.discountPercent > 0 && (
          <div className="font-bold text-[13px] rounded-full w-14 h-5 bg-white text-[#6A983C] absolute m-3 mt-2 sm:m-6 sm:mt-3 text-center">
            - {item.discountPercent} %
          </div>
        )}
        <img
          src={`/pic/${item.image}`}
          alt="bakso"
          className="w-[90%] rounded-lg m-2 mx-auto"
        />
      </div>
      <div className="mx-3 ">
        <div className="h-16 mt-3 sm:mt-0">
          <Link to={item.name}>
            <h1 className="text-lg font-semibold pt-1 sm:pt-1">{item.name}</h1>
          </Link>
          <p className="text-sm text-slate-400">{item.description}</p>
        </div>
        <div className="flex justify-between mt-5 sm:mt-1 items-center pt-3 sm:pt-2">
          <div>
            <h1 className="text-base sm:text-xl font-bold">
              <NumberFormat
                value={priceAfterDiscount}
                displayType={"text"}
                thousandSeparator={"."}
                decimalSeparator={","}
                prefix={"Rp "}
              />
            </h1>
            {item.discountPercent > 0 && (
              <p className="text-sm text-slate-400">
                <s>
                  <NumberFormat
                    value={item.originalPrice}
                    displayType={"text"}
                    thousandSeparator={"."}
                    decimalSeparator={","}
                    prefix={"Rp "}
                  />
                </s>
              </p>
            )}
          </div>
          <button className="overflow-hidden text-lg pt-2 font-bold rounded-2xl w-14 sm:w-32 h-10 sm:h-10 text-white bg-[#6A983C] border-solid border-[#46760A] p-3 hover:bg-[#598033] hover:shadow-lg focus:bg-[#4a692a] focus:shadow-lg focus:outline-none focus:ring-0 active:bg-green-200 active:shadow-lg transition duration-150 ease-in-out ">
            Buy Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContentCard;
